var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { t } from '@mp/locale';
import Button from '../../button';
import Map from "../Map/Map";
export default function PropertyFound(_a) {
    var extendedCoverage = _a.extendedCoverage, searchableAddress = _a.searchableAddress, nextButton = _a.nextButton, buttonDisabled = _a.buttonDisabled, props = __rest(_a, ["extendedCoverage", "searchableAddress", "nextButton", "buttonDisabled"]);
    // Update this with information about extended_coverage or errors
    var mapType = extendedCoverage ? 'warning' : 'success';
    return (_jsxs("div", __assign({ className: "flexColumn" }, { children: [_jsxs("p", __assign({ "data-qa": "address-confirmed", className: "capture-services-map-banner capture-services-address-".concat(mapType) }, { children: [" ", t("CAPTURE_SERVICES.SCHEDULER.ADDRESS.".concat(mapType.toLocaleUpperCase(), ".MESSAGE")), " "] })), _jsx(Map, { address: searchableAddress, mapType: mapType }), _jsx("div", __assign({ className: "position-right" }, { children: _jsx(Button, { className: "button-new", dark: true, "data-qa": "address-confirmed-button", label: t("CAPTURE_SERVICES.SCHEDULER.next"), onClick: nextButton, disabled: buttonDisabled, buttonType: "primary", htmlId: "address-confirmed-button" }) }))] })));
}
